"use client";

import CustomizationSection from "@/components/entities/customization";
import S from "./index.module.scss";
import DetailHero from "./_components/detail-hero";
import ProductShowcase from "./_components/product-showcase";
import DesignStory from "./_components/design-story";
import TechnicalProperties from "./_components/technical-properties";
import PhotoGallery from "./_components/photo-gallery";
import { useProductData } from "./hooks/useProductData";

const CatalogDetailView = () => {
  const { product } = useProductData();

  if (!product) return null;

  return (
    <main className={S.detailPage}>
      <DetailHero name={product.name} top_banner_image={product.top_banner_image} is_preorder={product.is_preorder} />
      <ProductShowcase product={product} />

      <DesignStory title={product.short_description} description={product.description} />

      <TechnicalProperties properties={product.properties} properties_image={product.properties_image} />

      <PhotoGallery gallery={product.gallery} />

      <CustomizationSection />
    </main>
  );
};

export default CatalogDetailView;
